import React from 'react';
import { Box, Typography } from '@mui/material';
import Countdown from 'react-countdown';
import './Welcome.css';

const Welcome = () => {
  const targetDate = new Date('2025-02-06T00:00:00'); // Set your target date

  // Custom renderer to match the screenshot style
  const renderer = ({ days, hours, minutes, seconds }) => (
    <Box className="countdown-container">
      <Box className="countdown-segment">
        <Typography className="countdown-number">{days}</Typography>
        <Typography className="countdown-label">Days</Typography>
      </Box>
      <Box className="countdown-segment">
        <Typography className="countdown-number">{hours}</Typography>
        <Typography className="countdown-label">Hours</Typography>
      </Box>
      <Box className="countdown-segment">
        <Typography className="countdown-number">{minutes}</Typography>
        <Typography className="countdown-label">Minutes</Typography>
      </Box>
      <Box className="countdown-segment">
        <Typography className="countdown-number">{seconds}</Typography>
        <Typography className="countdown-label">Seconds</Typography>
      </Box>
    </Box>
  );

  return (
    <Box>
        <Box className="welcome-container">
            {/* Picture Section */}
            <Box
                component="img"
                src="wedding_image_3.jpg" // Replace with the actual image path
                alt="Wedding"
                className="welcome-image"
            />

            <Box className="overlay">
                <Typography variant="h6" className="subheading">The Wedding of</Typography>
                <Typography variant="h1" className="bride-groom-names">
                Chandana & Niranjan
                </Typography>
            </Box>
        </Box>

        {/* Countdown Timer Section */}
        <Box className="countdown-timer">
            {/* <Typography variant="h4" gutterBottom>
            Save the Date
            </Typography> */}
            <Countdown date={targetDate} renderer={renderer} />
        </Box>
    </Box>
  );
};

export default Welcome;
